<template>
    <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>
  
<script>
  import * as echarts from 'echarts';
  import resize from './mixins/resize'
  
  export default {
    mixins: [resize],
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      id: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '1000px'
      }
    },
    data() {
      return {
        chart: null,
        dateData: [],
        showData: [],
        clickData: [],
        invokeSuccessData: [],
        consumeData:[]
      }
    },
    mounted() {
      // 点击数据
      this.initChart()
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      initChart() {
        this.chart = echarts.init(document.getElementById(this.id))
        this.getNowFormatDate()
        this.chart.setOption({
          backgroundColor: '#384047',
          title: {
            top: 20,
            textStyle: {
              fontWeight: 'normal',
              fontSize: 16,
              color: '#F1F1F3'
            },
            left: '1%'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          legend: {
            top: 20,
            icon: 'rect',
            itemWidth: 14,
            itemHeight: 5,
            itemGap: 13,
            data: ['总消耗（元）', '总展示（次）', '总点击（次）', '总唤醒（次）'],
            right: '4%',
            textStyle: {
              fontSize: 12,
              color: '#F1F1F3'
            }
          },
          grid: {
            top: 100,
            left: '2%',
            right: '2%',
            bottom: '2%',
            containLabel: true
          },
          xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          data: this.dateData
         }],
          yAxis: [{
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                color: '#57617B'
              }
            },
          }],
          series: [{
            name: '总消耗（元）',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(137, 189, 27, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(137, 189, 27, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(199,182,253)',
                borderColor: 'rgba(199,182,253)',
                borderWidth: 12
              }
            },
            data: this.consumeData
          }, {
            name: '总展示（次）',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0, 136, 212, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(0, 136, 212, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,136,212)',
                borderColor: 'rgba(0,136,212,0.2)',
                borderWidth: 10
              }
            },
            data: this.showData
          }, {
            name: '总点击（次）',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(68,170,71, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(68,170,71, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(68,170,71)',
                borderColor: 'rgba(68,170,71,0.2)',
                borderWidth: 12
  
              }
            },
            data: this.clickData
          }, {
            name: '总唤醒（次）',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(255,232,148, 0.3)'
              }, {
                offset: 0.8,
                color: 'rgba(255,232,148, 0)'
              }], false),
              shadowColor: 'rgba(0, 0, 0, 0.1)',
              shadowBlur: 10
            }
          },
          itemStyle: {
            normal: {
              color: 'rgb(255,232,148)',
              borderColor: 'rgba(255,232,148,0.2)',
              borderWidth: 12
            }
            },
            data: this.invokeSuccessData
          }]
        });
      },
      getNowFormatDate() {
            this.dateData = []
            for(var i=0;i<7;i++){
              let date = new Date()
              let milTime = date.getTime()
              milTime = milTime - i * 5 * 60 * 1000
              date.setTime(milTime)
              let hour=date.getHours()
              let min = date.getMinutes()
              let second=date.getSeconds()
              let h = hour < 10 ? ('0' + hour) : hour
              let m = min < 10 ? ('0' + min) : min
              let s = second < 10 ? ('0' + second) : second
              this.dateData.push(h + ":" + m + ":" + s )
            }
            this.dateData.reverse()
            // 准备好展示数据
            this.generalShow()
        },
        generalShow() { //根据最小值和最大值产生一个随机数
          this.showData = []
          for(var i=0; i<8;i++){
            var a = Math.random() * (2000000 - 5000000) + 5000000;
            var b = parseInt(a,10);
            this.showData.push(b)
          }
          this.generalClick()
        },
        generalClick() { //根据最小值和最大值产生一个随机数
          this.clickData = []
          for(var i=0; i<this.showData.length;i++){
            const impl= this.showData[i]
            var clickD = impl * (Math.random() * (0.45 - 0.1) +0.1);
            var clickD2 = parseInt(clickD,10);
            this.clickData.push(clickD2)
          }
          this.generalInvokeSuccess()
        },
        generalInvokeSuccess() { //根据最小值和最大值产生一个随机数
          this.invokeSuccessData = []
          for(var i=0; i<this.clickData.length;i++){
            const clickDataNum=this.clickData[i]
            var invokeSuccess = clickDataNum * (Math.random() * (0.8 - 0.6) + 0.6);
            var invokeSuccessDat = parseInt(invokeSuccess,10);
            this.invokeSuccessData.push(invokeSuccessDat)
          }
          this.totalConsumption()
        },
        totalConsumption() { //根据最小值和最大值产生一个随机数
          this.consumeData = []
          for(var i=0; i<this.invokeSuccessData.length;i++){
            var totalConsume = parseInt(Math.random() * (100000-30000),10) + 30000
            this.consumeData.push(totalConsume)
          }
        }
    }
  }
  </script>

<style scoped>


</style>
  